var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeAndAttendanceCheckIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 170,
    viewBox: "0 0 175 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10059_92342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.145 145.604C174.664 113.071 174.664 60.3239 142.145 27.7906C109.626 -4.74259 56.9031 -4.74259 24.3843 27.7906C-8.13444 60.3239 -8.13443 113.071 24.3843 145.604C56.9031 178.137 109.626 178.137 142.145 145.604Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.69 35.7332C164.52 36.138 162.423 34.7029 162.019 32.5319C161.614 30.3609 163.012 28.3003 165.182 27.8587C167.352 27.454 169.448 28.8523 169.89 31.0232C170.258 33.1942 168.823 35.2916 166.69 35.7332Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.942 43.2774C171.581 43.535 170.22 42.6151 169.963 41.2536C169.705 39.8921 170.588 38.5675 171.985 38.2731C173.346 38.0155 174.707 38.8986 174.965 40.2969C175.222 41.6584 174.303 43.0198 172.942 43.2774Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4087 151.753C3.23867 152.157 1.1422 150.722 0.737618 148.551C0.333037 146.38 1.73068 144.32 3.90071 143.878C6.07074 143.474 8.16721 144.872 8.60857 147.043C9.01315 149.214 7.57873 151.348 5.4087 151.753Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6605 159.297C10.2996 159.555 8.93873 158.635 8.68127 157.273C8.4238 155.912 9.30653 154.587 10.7042 154.293C12.065 154.035 13.4259 154.918 13.6834 156.316C13.9408 157.678 13.0213 159.039 11.6605 159.297Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11964 29.5148C6.94961 29.9195 4.85314 28.4845 4.44856 26.3135C4.04397 24.1793 5.44162 22.0819 7.61165 21.6771C9.78168 21.2723 11.8781 22.6706 12.3195 24.8416C12.7241 26.9758 11.2897 29.11 9.11964 29.5148Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6848 160.915C119.813 160.915 150.721 129.993 150.721 91.8484C150.721 53.7036 119.813 22.7812 81.6848 22.7812C43.5571 22.7812 12.6484 53.7036 12.6484 91.8484C12.6484 129.993 43.5571 160.915 81.6848 160.915Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5039 91.8484C28.5039 121.249 52.3007 145.056 81.688 145.056C111.075 145.056 134.872 121.212 134.872 91.8484C134.872 62.448 111.039 38.6406 81.688 38.6406C52.3007 38.6406 28.5039 62.448 28.5039 91.8484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.041 56.0448C111.625 47.5448 99.1195 42.3197 85.3638 42.3197C55.9764 42.3197 32.1796 66.127 32.1796 95.5274C32.1796 109.253 37.3656 121.727 45.8619 131.146C35.1588 121.395 28.4648 107.376 28.4648 91.7742C28.4648 62.3738 52.2984 38.5664 81.649 38.5664C97.2805 38.64 111.331 45.337 121.041 56.0448Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6876 52.4017C80.5842 52.4017 79.7383 51.5185 79.7383 50.4514V47.8389C79.7383 46.735 80.621 45.8887 81.6876 45.8887C82.7543 45.8887 83.637 46.7718 83.637 47.8389V50.4514C83.637 51.5185 82.7543 52.4017 81.6876 52.4017Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9714 57.7011C61.0151 58.2531 59.8382 57.9219 59.2865 56.9652L57.9624 54.6838C57.4107 53.7271 57.7417 52.5496 58.698 51.9976C59.6543 51.4457 60.8312 51.7769 61.3829 52.7336L62.707 55.015C63.2219 55.9349 62.8909 57.1492 61.9714 57.7011Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5532 72.1249C47.0015 73.0816 45.8245 73.376 44.8683 72.8609L42.5879 71.5362C41.6316 70.9842 41.3374 69.8067 41.8523 68.85C42.404 67.8933 43.5809 67.599 44.5372 68.1141L46.8176 69.4388C47.7739 69.9907 48.0681 71.205 47.5532 72.1249Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2601 91.8478C42.2601 92.9517 41.3774 93.798 40.3107 93.798H37.6993C36.5959 93.798 35.75 92.9149 35.75 91.8478C35.75 90.7439 36.6327 89.8976 37.6993 89.8976H40.3107C41.3774 89.8608 42.2601 90.7439 42.2601 91.8478Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5539 111.57C48.1056 112.526 47.7746 113.704 46.8183 114.256L44.5379 115.58C43.5817 116.132 42.4047 115.801 41.853 114.844C41.3013 113.888 41.6323 112.71 42.5886 112.158L44.869 110.834C45.7885 110.282 47.0022 110.613 47.5539 111.57Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9707 125.996C62.927 126.548 63.2212 127.725 62.7063 128.682L61.3822 130.963C60.8305 131.92 59.6535 132.214 58.6973 131.699C57.741 131.147 57.4467 129.97 57.9617 129.013L59.2857 126.732C59.8374 125.775 61.0144 125.444 61.9707 125.996Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6848 131.295C82.7882 131.295 83.6342 132.178 83.6342 133.245V135.858C83.6342 136.962 82.7515 137.808 81.6848 137.808C80.5814 137.808 79.7355 136.925 79.7355 135.858V133.245C79.6987 132.141 80.5814 131.295 81.6848 131.295Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.401 125.996C102.357 125.444 103.534 125.775 104.086 126.732L105.41 129.013C105.962 129.97 105.631 131.147 104.675 131.699C103.718 132.251 102.541 131.92 101.99 130.963L100.665 128.682C100.114 127.725 100.445 126.548 101.401 125.996Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.818 111.571C116.37 110.614 117.547 110.32 118.503 110.835L120.783 112.159C121.739 112.711 122.034 113.889 121.519 114.846C120.967 115.802 119.79 116.097 118.834 115.582L116.553 114.257C115.597 113.705 115.266 112.491 115.818 111.571Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.082 91.8467C121.082 90.7428 121.965 89.8965 123.031 89.8965H125.643C126.746 89.8965 127.592 90.7796 127.592 91.8467C127.592 92.9506 126.709 93.7969 125.643 93.7969H123.031C121.965 93.7969 121.082 92.9138 121.082 91.8467Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.818 72.1237C115.266 71.167 115.597 69.9895 116.553 69.4376L118.834 68.1129C119.79 67.5609 120.967 67.8921 121.519 68.8488C122.07 69.8055 121.739 70.983 120.783 71.535L118.503 72.8596C117.547 73.3748 116.37 73.0804 115.818 72.1237Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4 57.7023C100.444 57.1504 100.15 55.9729 100.665 55.0162L101.989 52.7348C102.541 51.7781 103.718 51.4837 104.674 51.9989C105.63 52.5508 105.924 53.7283 105.409 54.685L104.085 56.9664C103.534 57.9231 102.32 58.2543 101.4 57.7023Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1892 93.1365H81.6818C80.9462 93.1365 80.3945 92.5477 80.3945 91.8486V67.7469C80.3945 67.0109 80.983 66.459 81.6818 66.459C82.3807 66.459 82.9691 67.0477 82.9691 67.7469V90.5239H99.1892C99.9248 90.5239 100.477 91.1127 100.477 91.8118C100.477 92.5109 99.888 93.1365 99.1892 93.1365Z",
    fill: "url(#paint0_linear_10059_92342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2624 71.1686H79.1132C78.2305 71.1686 77.6788 70.2119 78.1569 69.4392L80.7316 65.3915C81.1729 64.6924 82.166 64.6924 82.6073 65.3915L85.182 69.4392C85.6601 70.1751 85.1452 71.1686 84.2624 71.1686Z",
    fill: "url(#paint1_linear_10059_92342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9492 94.6461V89.4946C96.9492 88.6115 97.9055 88.0595 98.6779 88.5379L102.724 91.1136C103.423 91.5552 103.423 92.5487 102.724 92.9903L98.6779 95.566C97.9055 96.0444 96.9492 95.5292 96.9492 94.6461Z",
    fill: "url(#paint2_linear_10059_92342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4128 104.211C62.2289 103.916 62.3024 103.512 62.5967 103.291L80.2511 91.4792C80.5454 91.2952 80.95 91.3688 81.1706 91.6632C81.3545 91.9576 81.281 92.3623 80.9867 92.5831L63.3323 104.395C63.0012 104.616 62.5967 104.505 62.4128 104.211Z",
    fill: "url(#paint3_linear_10059_92342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7968 91.81C86.7968 94.6434 84.5165 96.9615 81.6844 96.9615C78.8523 96.9615 76.5352 94.6802 76.5352 91.81C76.5352 89.0135 78.8155 86.6953 81.6844 86.6953C84.4797 86.7321 86.7968 89.0135 86.7968 91.81Z",
    fill: "url(#paint4_linear_10059_92342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0392 91.8488C84.0392 93.1735 82.9726 94.2406 81.6485 94.2406C80.3244 94.2406 79.2578 93.1735 79.2578 91.8488C79.2578 90.5609 80.3244 89.457 81.6485 89.457C82.9726 89.457 84.0392 90.5241 84.0392 91.8488Z",
    fill: "url(#paint5_linear_10059_92342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.253 157.956C159.298 146.905 159.298 128.989 148.253 117.939C137.207 106.888 119.299 106.888 108.253 117.939C97.208 128.989 97.208 146.905 108.253 157.956C119.299 169.006 137.207 169.006 148.253 157.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.245 167.541C111.914 167.541 98.6367 154.258 98.6367 137.92C98.6367 121.582 111.914 108.299 128.245 108.299C144.575 108.299 157.853 121.582 157.853 137.92C157.853 154.258 144.575 167.541 128.245 167.541ZM128.245 110.948C113.349 110.948 101.248 123.054 101.248 137.957C101.248 152.859 113.349 164.965 128.245 164.965C143.141 164.965 155.241 152.859 155.241 137.957C155.241 123.054 143.141 110.948 128.245 110.948Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.741 156.512C142.988 154.034 149.287 143.714 146.81 133.462C144.332 123.21 134.017 116.909 123.769 119.387C113.522 121.866 107.223 132.186 109.701 142.438C112.178 152.69 122.494 158.991 132.741 156.512Z",
    fill: "url(#paint6_linear_10059_92342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.832 17.1875V23.8845C80.0388 23.5901 82.2824 23.4429 84.5996 23.4429C86.8799 23.4429 89.1235 23.5901 91.3671 23.8845V17.1875H77.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4453 4.3459V14.3546C69.4453 16.7095 71.3947 18.6598 73.7854 18.6598H95.4121C97.8028 18.6598 99.7522 16.7095 99.7522 14.3546V4.3459C99.7522 1.95412 97.8028 0.00390625 95.4121 0.00390625H73.7854C71.3947 0.00390625 69.4453 1.95412 69.4453 4.3459Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3967 12.551C91.6611 12.551 91.1094 11.9623 91.1094 11.2632V7.43632C91.1094 6.70039 91.6979 6.14844 92.3967 6.14844C93.1323 6.14844 93.684 6.73718 93.684 7.43632V11.2632C93.684 11.9991 93.0955 12.551 92.3967 12.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6037 12.551C83.8681 12.551 83.3164 11.9623 83.3164 11.2632V7.43632C83.3164 6.70039 83.9049 6.14844 84.6037 6.14844C85.3393 6.14844 85.891 6.73718 85.891 7.43632V11.2632C85.891 11.9991 85.3025 12.551 84.6037 12.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8029 12.551C76.0673 12.551 75.5156 11.9623 75.5156 11.2632V7.43632C75.5156 6.70039 76.1041 6.14844 76.8029 6.14844C77.5385 6.14844 78.0902 6.73718 78.0902 7.43632V11.2632C78.0902 11.9991 77.5018 12.551 76.8029 12.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.268 143.123L119.611 138.689C118.672 137.556 118.834 135.905 119.967 134.967C121.1 134.028 122.75 134.19 123.689 135.323L125.696 137.783L132.234 132.572C133.367 131.665 135.017 131.86 135.924 132.992C136.83 134.125 136.636 135.776 135.503 136.682L126.926 143.479C125.793 144.418 124.175 144.224 123.268 143.123Z",
    fill: "url(#paint7_linear_10059_92342)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10059_92342",
    x1: 85.5266,
    y1: 86.4671,
    x2: 99.7587,
    y2: 73.2984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10059_92342",
    x1: 79.8675,
    y1: 69.5932,
    x2: 83.0267,
    y2: 65.0429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10059_92342",
    x1: 98.5589,
    y1: 93.9018,
    x2: 102.507,
    y2: 89.7636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10059_92342",
    x1: 67.1574,
    y1: 101.228,
    x2: 73.1686,
    y2: 90.5616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10059_92342",
    x1: 79.1576,
    y1: 94.395,
    x2: 84.5366,
    y2: 87.7862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10059_92342",
    x1: 79.2589,
    y1: 91.8498,
    x2: 84.0409,
    y2: 91.8498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10059_92342",
    x1: 121.427,
    y1: 149.425,
    x2: 135.101,
    y2: 120.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10059_92342",
    x1: 118.997,
    y1: 138.046,
    x2: 136.499,
    y2: 138.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10059_92342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 170,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeAndAttendanceCheckIn);
export default __webpack_public_path__ + "static/media/time-and-attendance-check-in.022f5f10a73c19c661a2bf90563224a1.svg";
export { ForwardRef as ReactComponent };